import PosthogService from '~/services/posthog/PosthogService';

export interface IShiftDetailsInviteClickedPayload {
  shiftId: string;
}

/**
 * Fires when the user clicks "Invite" from the Shift Details page
 * Event: dental_portal:shift_details:invite_clicked
 */
export function fireShiftDetailsInviteClicked(payload: IShiftDetailsInviteClickedPayload): void {
  PosthogService.getInstance().track('dental_portal:shift_details:invite_clicked', {
    invite_type: 'Existing Shift',
    shift_status: 'Open',
    shift_id: payload.shiftId,
  });
}
